import CreatorDetailCollectionPage from './CreatorDetailCollectionPage';

export default CreatorDetailCollectionPage;